export const TRACK_EVENT = {
  CATEGORY: 'Perform Apparel Landing Page',
  ACTION: 'Testimonials - Scroll',
};

export const DESKTOP_CONTENT_PADDING = 126;
